/*
 * @Author: xuejian3721
 * @Date: 2021-07-08 09:46:23
 * @LastEditors: zhenfangyu
 * @LastEditTime: 2025-05-27 14:51:54
 */
import Vue from 'vue'
import App from './App.vue'
import router from '@/router'
import store from '@/store'
import Vant from 'vant'
import 'vant/lib/index.css'
import 'normalize.css'
import '@/assets/styles/base.scss'
import '@/assets/styles/theme/blue/base.scss'
import 'es6-promise/auto'
import 'pdfh5/css/pdfh5.css'
import { parseQuery } from '@/utils/location'
import { loadHarmonyOS, getPlatformAgent } from './utils/index'
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import Pdfh5 from 'pdfh5'
import { aliBuriedConfig, sdkUrl } from './burying'
import pointFunc from './burying/point-func'

Vue.prototype.$Pdfh5 = Pdfh5

Vue.config.productionTip = false
Vue.use(Vant)
Vue.use(Viewer)

Vue.use(pointFunc, aliBuriedConfig, sdkUrl)

const hashQuery = parseQuery(location.hash.replace(/#.+\?/, '?'))
// 兼容search参数
const query = parseQuery(location.search)
store.dispatch('changeTheme')
const title = hashQuery.merchantName || query.merchantName
if (title) {
  store.commit('setTitle', title)
}
// 获取灰度key和value
const shade = hashQuery.shade || query.shade
const shadeValue = hashQuery.shadeValue || query.shadeValue
if (shade && shadeValue) {
  store.commit('setGrayscale', { shade, shadeValue })
}

function render() {
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
}

// 判断鸿蒙加载
console.log(getPlatformAgent().isHarmonyOS, '是否鸿蒙系统')
if (getPlatformAgent().isHarmonyOS) {
  loadHarmonyOS().then(() => {
    render()
  })
} else {
  render()
}
